import { useState, useCallback } from "react";
import allCourses from "../data/course1.json";

const STORAGE_KEY = "na_course_clicks";

function getClickCounts() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

function saveClickCounts(counts) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(counts));
  } catch {}
}

/**
 * Returns the 2 most-clicked available courses.
 * Falls back to courses 1 & 2 when no click data exists.
 * Course 3 (Coming Soon) is excluded from featured slots.
 */
export default function useFeaturedCourses() {
  const [counts, setCounts] = useState(() => getClickCounts());

  const available = allCourses.filter(c => c.course1_modules !== "Coming Soon");

  // Sort by click count descending, default order preserved on tie
  const ranked = [...available].sort((a, b) => {
    const ca = counts[a.id] || 0;
    const cb = counts[b.id] || 0;
    return cb - ca;
  });

  const featured = ranked.slice(0, 2);

  const trackClick = useCallback((courseId) => {
    setCounts(prev => {
      const next = { ...prev, [courseId]: (prev[courseId] || 0) + 1 };
      saveClickCounts(next);
      return next;
    });
  }, []);

  return { featured, trackClick, counts };
}
